/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowLeftBig16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeftBig16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M6.506 3.708A1 1 0 0 0 5.09 2.293L.293 7.09a1 1 0 0 0 0 1.414l4.798 4.798a1 1 0 0 0 1.415-1.415l-1.414-1.412a10.001 10.001 0 0 0-1.758-1.4l-.747-.469.046-.046.96.137a10 10 0 0 0 1.413.1h9.79a1 1 0 0 0 0-2h-9.79a10 10 0 0 0-1.414.1l-.959.138-.047-.047.75-.47a10 10 0 0 0 1.757-1.4l1.413-1.411Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowLeftBig24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeftBig24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M2.404 13.05a1.495 1.495 0 0 1 0-2.115l5.633-5.643c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41L6.741 9.42a9.992 9.992 0 0 1-1.768 1.407l-.342.214.208.207a10 10 0 0 1 2.24-.255H21a1 1 0 1 1 0 2H7.078a10 10 0 0 1-2.24-.254l-.207.207.342.214c.641.401 1.233.872 1.768 1.407l2.716 2.716c.39.39.39 1.02 0 1.41-.39.39-1.03.39-1.42 0L2.404 13.05Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowLeftBig = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowLeftBig(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconArrowLeftBig16 {...iconProps} />;
        case '24':
            return <IconArrowLeftBig24 {...iconProps} />;
        default:
            return <IconArrowLeftBig24 {...iconProps} />;
    }
});
